import React from "react";

import Asset from "../components/common/Asset/Asset";

export const SplitSplashBackgroundAsset = Asset.create({
	src: "/img/split_splash_background.png",
	sources: { webp: "/img/split_splash_background.webp" },
	placeholder: "/img/split_splash_background_low.jpg",
});

export const MiscBackgroundAsset = Asset.create({
	src: "/img/misc_background.png",
	sources: { webp: "/img/misc_background.webp" },
	placeholder: "/img/misc_background_low.jpg",
});

export { ReactComponent as IconBrightMileLogoFull } from "./svg/3_Navigation/Logo_Brightmile_gold.svg";
export { ReactComponent as IconBrightMileLogoWord } from "./svg/Ic_brightmile_logo.svg";
export { ReactComponent as IconBrightMileLogo } from "./svg/3_Navigation/Ic_brightmile_logo.svg";
export { ReactComponent as IconFiveKeysLogoFull } from "./svg/3_Navigation/Engage_Logo.svg";
export { ReactComponent as IconFiveKeysLogoDark } from "./svg/Engage_Logo_Dark.svg";
export { ReactComponent as IconTick } from "./svg/2_Global_Icons/Ic_tick.svg";
export { ReactComponent as IconInfo } from "./svg/Ic_info.svg";
export { ReactComponent as IconUpload } from "./svg/2_Global_Icons/Ic_upload.svg";
export { ReactComponent as IconCsv } from "./svg/2_Global_Icons/Ic_csv.svg";
export { ReactComponent as IconClose } from "./svg/2_Global_Icons/Ic_close.svg";
export { ReactComponent as IconInvite } from "./svg/2_Global_Icons/Ic_invite.svg";
export { ReactComponent as IconArrowRight } from "./svg/arrow_right.svg";
export { ReactComponent as IconPillarArrowIncreaseAlot } from "./svg/arrow_icons/pillar_arrow_increasing_alot.svg";
export { ReactComponent as IconPillarArrowIncreaseSlightly } from "./svg/arrow_icons/pillar_arrow_increasing_slightly.svg";
export { ReactComponent as IconInsightGeneral } from "./svg/insight_icons/general.svg";
export { ReactComponent as IconInsightWhatsNew } from "./svg/insight_icons/whats_new.svg";
export { ReactComponent as IconInsightFatigue } from "./svg/insight_icons/fatigue.svg";
export { ReactComponent as IconInsightDistraction } from "./svg/insight_icons/distraction.svg";
export { ReactComponent as IconInsightEco } from "./svg/insight_icons/eco.svg";
export { ReactComponent as IconInsightSpeeding } from "./svg/insight_icons/speed.svg";
export { ReactComponent as IconInsightRisk } from "./svg/insight_icons/risk.svg";
export { ReactComponent as IconInsightFeedback } from "./svg/insight_icons/feedback.svg";
export { ReactComponent as IconSupport } from "./svg/3_Navigation/ic_help.svg";
export { ReactComponent as IconMore } from "./svg/2_Global_Icons/Ic_more.svg";
export { ReactComponent as IconReminder } from "./svg/2_Global_Icons/Reminder.svg";
export { ReactComponent as IconInvitedAvatar } from "./svg/4_Profile/Invited_avatar.svg";
export { ReactComponent as IconInvitedError } from "./svg/4_Profile/Invited_error.svg";
export { ReactComponent as IconHamburger } from "./svg/3_Navigation/Ic_hamburger.svg";
export { ReactComponent as IconRisk } from "./svg/1_5pillars/ic_performance_risk.svg";
export { ReactComponent as IconFatigue } from "./svg/1_5pillars/ic_performance_fatigue.svg";
export { ReactComponent as IconSpeed } from "./svg/1_5pillars/ic_performance_speed.svg";
export { ReactComponent as IconDistraction } from "./svg/1_5pillars/ic_performance_distraction.svg";
export { ReactComponent as IconEco } from "./svg/1_5pillars/ic_performance_eco.svg";
export { ReactComponent as IconHarshAcceleration } from "./svg/1_5pillars/harsh_acceleration.svg";
export { ReactComponent as IconHarshBraking } from "./svg/1_5pillars/harsh_braking.svg";
export { ReactComponent as IconHwSeatbelt } from "./svg/hardware_pillars/hw_seatbelt_icon.svg";
export { ReactComponent as IconHwIdling } from "./svg/hardware_pillars/hw_idling_icon.svg";
export { ReactComponent as IconHwBraking } from "./svg/hardware_pillars/hw_harsh_braking_icon.svg";
export { ReactComponent as IconHwCornering } from "./svg/hardware_pillars/hw_cornering_icon.svg";
export { ReactComponent as IconHwAcceleration } from "./svg/hardware_pillars/hw_acceleration_icon.svg";
export { ReactComponent as IconHwExcessiveSpeed } from "./svg/hardware_pillars/hw_excessive_speed_icon.svg";
export { ReactComponent as IconHwBackingAtStart } from "./svg/hardware_pillars/hw_backing_at_start_icon.svg";
export { ReactComponent as IconHwCloseFollowing } from "./svg/hardware_pillars/hw_close_following_icon.svg";
export { ReactComponent as IconHwSmoking } from "./svg/hardware_pillars/hw_smoking_icon.svg";
export { ReactComponent as IconHwCellPhoneUse } from "./svg/hardware_pillars/hw_cell_phone_use_icon.svg";
export { ReactComponent as IconHwFoodAndDrink } from "./svg/hardware_pillars/hw_food_and_drink_icon.svg";
export { ReactComponent as ScoreBackground } from "./svg/1_5pillars/driver_score.svg";
export { ReactComponent as ScoreCircles } from "./svg/1_5pillars/5_keys_circles.svg";
export { ReactComponent as IconNoResults } from "./svg/3_Navigation/Ic_noresult.svg";
export { ReactComponent as IconSearch } from "./svg/3_Navigation/Ic_search.svg";
export { ReactComponent as IconTotalMiles } from "./svg/5_Dashboard/total_mileage.svg";
export { ReactComponent as IconTotalTrips } from "./svg/5_Dashboard/total_trips.svg";
export { ReactComponent as IconLiveDrivers } from "./svg/5_Dashboard/live_drivers.svg";
export { ReactComponent as IconMail } from "./svg/4_Profile/Ic_profile_email.svg";
export { ReactComponent as IconNoDrivers } from "./svg/5_Dashboard/invitedrivers__icon.svg";
export { ReactComponent as IconError } from "./svg/2_Global_Icons/Ic_error.svg";
export { ReactComponent as IconExport } from "./svg/2_Global_Icons/Ic_export.svg";
export { ReactComponent as IconSpinner } from "./svg/spinner.svg";
export { ReactComponent as IconSpinnerB } from "./svg/spinner-b.svg";
export { ReactComponent as FiveKeysLoadingTop } from "./svg/five-keys-logo-top.svg";
export { ReactComponent as FiveKeysLoadingBottom } from "./svg/five-keys-logo-bottom.svg";
export { ReactComponent as IconWarning } from "./svg/4_Profile/Error_Icon.svg";
export { ReactComponent as IconArrowUp } from "./svg/2_Global_Icons/Ic_arrowup.svg";
export { ReactComponent as IconCalender } from "./svg/2_Global_Icons/Ic_calendar.svg";
export { ReactComponent as IconLine } from "./svg/2_Global_Icons/Ic_line.svg";
export { ReactComponent as MixpanelLogo } from "./svg/mixpanel.svg";
export { ReactComponent as FirebaseLogo } from "./svg/firebase-logo.svg";
export { ReactComponent as IconNoFiles } from "./svg/fileManager_icons/no_files.svg";
export { ReactComponent as IconDriver } from "./svg/leaderboard_icons/driver.svg";
export { ReactComponent as IconTeam } from "./svg/leaderboard_icons/team.svg";
export { ReactComponent as IconTeamPodium } from "./svg/leaderboard_icons/team-leaderboard-podium.svg";
export { ReactComponent as IconDriverPodium } from "./svg/leaderboard_icons/driver-leaderboard-podium.svg";
export { ReactComponent as IconTrophy } from "./svg/trophy.svg";
